import * as React from "react";

import {t} from "i18next";
import _ from "lodash";

// components
import {Card, Icon, Label, SemanticCOLORS, SemanticICONS} from "semantic-ui-react";
import SelectField from "../../../components/SelectField";
import TextField from "../../../components/TextField";

import {WorkflowStatusDto, RoleDto, WorkflowStatusDtoType, WorkflowDtoType, WorkflowType} from "../../../services/Client";

interface IWorkflowStateProps {
    workflowState: WorkflowStatusDto;
    workflowType: WorkflowDtoType;
    roles: RoleDto[];
    edit: boolean;
    addState: () => void;
    deleteState: () => void;
    onChange: (state: WorkflowStatusDto) => void;
}

interface IWorkflowStateState {
    typeDS: WorkflowStatusDtoType[];
}

class WorkflowState extends React.Component<IWorkflowStateProps, IWorkflowStateState> {

    constructor(props: IWorkflowStateProps) {
        super(props);
        let typeDS: WorkflowStatusDtoType[] = [];
        _.forEach(WorkflowStatusDtoType, (val) => {
            if (val !== WorkflowStatusDtoType.APPROVED && val !== WorkflowStatusDtoType.REJECTED)
                typeDS.push(val);
        });
        this.state = {
            typeDS: typeDS
        };
    }

    updateWF(fieldName: string, value: any) {
        let {workflowState} = this.props;
        workflowState[fieldName] = value;
        this.props.onChange(workflowState);
    }

    renderWfStatusBtn(color: SemanticCOLORS, iconName: SemanticICONS, onClick: () => void) {
        return (
            <Label
                as='a'
                color={color}
                ribbon='right'
                onClick={() => this.props.edit && onClick()}
                icon={
                    <Icon
                        name={iconName}
                        link={true}
                        disabled={!this.props.edit}
                        fitted={true}
                    />
                }
            />
        );
    }

    renderStepName() {
        return (
            <TextField
                id={"workflow-state-name-input-" + this.props.workflowState.sequenceNumber}
                disabled={!this.props.edit}
                value={this.props.workflowState.name}
                onBlur={(e: any, d: any) => {
                    if (this.props.workflowState.name !== d) {
                        this.updateWF("name", d);
                    }
                }}
            />
        );
    }

    renderType() {
        if (this.props.workflowState.type === WorkflowStatusDtoType.APPROVED)
            return <div />;

        let typeDS = this.state.typeDS;
        if (this.props.workflowType === WorkflowDtoType.OPTION_BASIC) {
            typeDS = this.state.typeDS.filter(p => p !== WorkflowStatusDtoType.TRANSLATION);
        }
        if(this.props.workflowType === WorkflowDtoType.KUMA) {
            typeDS = this.state.typeDS.filter(p=>p === WorkflowStatusDtoType.MAINTENANCE || p === WorkflowStatusDtoType.APPROVAL);
        }

        return (
            <div style={this.props.workflowState.sequenceNumber === 0 ? {marginTop: 26.78} : {}}>
                <SelectField
                    dataSource={typeDS}
                    value={this.props.workflowState.type}
                    rendererKey={(v) => t("WORKFLOW:" + v.toString())}
                    disabled={!this.props.edit}
                    clearable={false}
                    onChange={(val: WorkflowStatusDtoType) => this.updateWF("type", val)}
                />
            </div>
        );
    }

    renderRoles() {
        return (
            <SelectField
                disabled={!this.props.edit}
                multi={false}
                searchable={false}
                clearable={false}
                dataSource={this.props.roles}
                value={this.props.roles.find((r) => r.name === this.props.workflowState.role.name)}
                rendererKey={(role: RoleDto) => role.name}
                onChange={(selectedValue) => selectedValue &&
                    this.updateWF("role", selectedValue as RoleDto)}
            />
        );
    }

    renderResetPoint() {
        if (this.props.workflowState.type === WorkflowStatusDtoType.APPROVED
            || this.props.workflowType === WorkflowDtoType.KUMA
            || (this.props.workflowType === WorkflowDtoType.OPTION_BASIC && this.props.workflowState.sequenceNumber !== 0)) {
            return <div />;
        } else {
            return (
                <div>
                    <div className="WorkflowHeadline">{t("WORKFLOW:RESET_POINT")}</div>
                    <SelectField
                        dataSource={[true, false]}
                        value={this.props.workflowState.resetPoint}
                        rendererKey={(val) => t("GLOBAL:" + (val ? "YES" : "NO"))}
                        disabled={this.props.workflowState.sequenceNumber === 0 ? true : !this.props.edit}
                        clearable={false}
                        onChange={(val: boolean) => this.updateWF("resetPoint", val)}
                    />
                </div>
            );
        }
    }

    renderTranslationRequest() {
        return (
            <div>
                <div className="WorkflowHeadline">{t("WORKFLOW:TRANSLATION_REQUEST")}</div>
                <SelectField
                    dataSource={['Option']}
                    value='Option'
                    readonly={true}
                    onChange={_}
                />
            </div>
        );
    }

    render() {
        let actionType: string | undefined = undefined;
        let color: string = "red";
        switch (this.props.workflowState.type) {
            case WorkflowStatusDtoType.APPROVAL:
                actionType = t("WORKFLOW:APPROVED_BY");
                color = "#d2eb2d";
                break;
            case WorkflowStatusDtoType.MAINTENANCE:
                actionType = t("WORKFLOW:EDITED_BY");
                color = "#afb1b2";
                break;
            case WorkflowStatusDtoType.APPROVED:
                color = "#13d246";
                break;
            case WorkflowStatusDtoType.FREEZE:
                actionType = t("WORKFLOW:APPROVED_BY");
                color = "#196a99";
                break;
            case WorkflowStatusDtoType.TRANSLATION:
                actionType = t("WORKFLOW:CANCEL_BY");
                color = "#FDA50F";
                break;
            default:
                break;
        }

        return (
            <Card style={{backgroundColor: color}}>
                <Card.Content>
                    {/** add step button */}
                    {this.props.workflowState.type !== WorkflowStatusDtoType.APPROVED && this.renderWfStatusBtn("black", "add", this.props.addState)}

                    <Card.Header>{this.renderStepName()}</Card.Header>

                    {/** delete step button */}
                    {this.props.workflowState.sequenceNumber !== 0 &&
                        this.props.workflowState.type !== WorkflowStatusDtoType.APPROVED &&
                        this.renderWfStatusBtn("red", "trash", this.props.deleteState)}

                    <Card.Meta>{this.renderType()}</Card.Meta>

                    <Card.Description>
                        {actionType &&
                            <div>
                                <div className="WorkflowHeadline">{actionType}</div>
                                {this.renderRoles()}
                            </div>
                        }

                        {this.props.workflowState.type !== WorkflowStatusDtoType.TRANSLATION && this.renderResetPoint()}
                        {this.props.workflowState.type === WorkflowStatusDtoType.TRANSLATION && this.renderTranslationRequest()}
                    </Card.Description>
                </Card.Content>
            </Card >
        );
    }
}

export default WorkflowState;



// WEBPACK FOOTER //
// ./src/views/AdminView/WorkflowTab/WorkflowState.tsx